import { CardDescription, CardTitle } from '@/shared/components/ui/card';

type OneItemHighlighterProps = {
  title: React.ReactNode;
  icon: React.ReactNode;
  subtitle?: React.ReactNode;
};

const OneItemHighlighter = ({
  title,
  subtitle,
  icon,
}: OneItemHighlighterProps) => {
  return (
    <div className="flex flex-row items-center gap-5 rounded-full border border-white/30 py-2 pl-2 pr-4">
      {icon}
      <div>
        <CardTitle className="text-sm font-[590]">{title}</CardTitle>
        {subtitle && <CardDescription>{subtitle}</CardDescription>}
      </div>
    </div>
  );
};
export default OneItemHighlighter;
